export default (shopList, shop, max = 4) => {
  const filteredShops = shopList.filter(s => s.id !== shop.id);
  const MAX = max;

  if (filteredShops.length <= MAX) {
    return filteredShops;
  }

  const createRandomIndex = () =>
    Math.floor(Math.random() * filteredShops.length);
  let finish = false;
  let randomArray = [];
  while (!finish) {
    const index = createRandomIndex();
    if (!randomArray.includes(index)) {
      randomArray = randomArray.concat(index);
    }

    finish = randomArray.length === max;
  }

  return randomArray.map(index => filteredShops[index]);
};
